// HorizontalBarChart.tsx
import React from "react";
import ApexCharts from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import useResponsive from "../../hooks/useResponsive";
import { useTheme } from "@mui/material/styles";

interface HorizontalBarOptionProps {
  name: string;
  data: number[];
  labels: string[];
}

export const FacilityHorizontalBarChart: React.FC<HorizontalBarOptionProps> = ({
  name,
  data,
  labels,
}) => {
  const theme = useTheme();

  const series = [
    {
      data: data,
    },
  ];

  const options: ApexOptions = {
    chart: {
      type: "bar",
      height: 200,
      toolbar: {
        show: false, // Disable the toolbar (menu)
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 2,
        borderRadiusApplication: "end",
        barHeight: "20%",
        horizontal: true, // Makes the bar chart horizontal
      },
    },
    dataLabels: {
      enabled: false, // Disable data labels
    },
    title: {
      text: name,
      align: "left",
    },
    grid: {
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    xaxis: {
      categories: labels,
      
    },
    colors: [`${theme.palette.primary.main}`, `${theme.palette.primary.light}`], // Add this line to set the colors for the series
  };

  return (
    <div>
      <ApexCharts options={options} series={series} type="bar" height={230} />
    </div>
  );
};

// BarChart.tsx

interface BarChartOptions {
  id: string[];
  labels: number[];
}

export const FacilityBarChart: React.FC<BarChartOptions> = ({
  id,
  labels,
}) => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  const isSmall = useResponsive("down", "sm", "xl");
  const series = [
    {
      name: "Sales",
      data: labels,
    },
  ];

  const options: ApexOptions = {
    chart: {
      type: "bar",
      toolbar: {
        show: false, // Disable the toolbar (menu)
      },
    },
    xaxis: {
      categories: id,
    },
    title: {
      text: "Active Employees Department",
      align: "left",
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: isSmall ? "15%" : isMedium ? "15%" : "15%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    grid: {
      row: {
        colors: ["#fff", "transparent"],
        opacity: 0.5,
      },
      show: true,
      borderColor: "#E7EAEE",
      strokeDashArray: 4, // Make the grid lines dotted
      position: "back",
    },
    colors: [`${theme.palette.primary.main}`, `${theme.palette.primary.light}`], // Add this line to set the colors for the series
  };

  return (
    <ApexCharts options={options} series={series} type="bar" height={350} />
  );
};
